import styled from 'styled-components'

import { Dropdown } from '../../../styles/defaults-header'
import { black, bordergray, lightergray } from '../../../styles/colors'

export const DropDown = Dropdown.extend`
  min-width: 800px;
  text-align: center;
`

export const DropDownItem = styled.div`
  transition: background-color .5s;
  border-right: 1px solid ${bordergray};
  background: ${props => (props.current ? '#EFEFEF' : 'none')};
  width: 25%;

  &:last-child {
    border-right: 0;
  }
  &:hover {
    background: ${lightergray};
  }

  p {
    transition: all 0.5s;
    margin: 0;
    margin-top: 1.25rem;
    font-weight: 500;
  }

  img {
    width: 95%;
    height: auto;
  }

  a {
    color: ${black};
    text-decoration: none;
    display: block;
    padding: 1.5rem 3rem;
  }
`

export const ImageContainer = styled.div`
  width: 100%;
  position: relative;

  &::before {
    padding-top: 100%;
    content: '';
    display: block;
  }
  
  div {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }
`



// WEBPACK FOOTER //
// ./src/components/Header/AssortimentMenu/styles.js